import {
  ComponentService,
  DataTransmissionService,
  DbCommonColumnName,
  KeyUsedByItem,
  MessageService,
  ResponseDataModel,
  ShowDefaultDialogService,
  ValidateCheckUtility,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';

export namespace InvoiceUtility {
  /**
   * 発注書データに紐づく請求書データを取得する
   * @param orderSheetTicketKey 発注書のチケットキー
   * @returns 請求書データ
   */
  export function fetchInvoiceByLinkOrderSheet(orderSheetTicketKey: string): Promise<any> {
    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    const orderSheetCondition = {
      [DbCommonColumnName.TICKET_TYPE]: 'OrderSheet',
      [DbCommonColumnName.TICKET_KEY]: orderSheetTicketKey,
    };

    const getInvoceTicket = (ticketKey: string) => {
      const invoiceCondition = {
        [DbCommonColumnName.TICKET_TYPE]: 'Invoice',
        [DbCommonColumnName.TICKET_KEY]: ticketKey,
      };

      return new Promise((resolve, reject) => {
        try {
          dtService
            .fetchRecord(ViewType.Edit, 'Invoice', invoiceCondition, null, false, null)
            .then((response) => resolve(response.data));
        } catch (e) {
          throw reject(e);
        }
      });
    };

    return new Promise<any>((resolve, reject) => {
      try {
        // 指定したレコードを取得する
        const callBack = (response: ResponseDataModel) => {
          if (!response.isCompleted) {
            resolve(undefined);
          }

          if (
            ValidateCheckUtility.isEmpty(response.data) ||
            ValidateCheckUtility.isEmpty(response.data['InvoiceTicketKey'])
          ) {
            resolve(undefined);
          }
          getInvoceTicket(response.data['InvoiceTicketKey']).then((response) => {
            resolve(response);
          });
        };
        dtService.fetchRecord(ViewType.Edit, 'OrderSheet', orderSheetCondition, callBack, false, null);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * 発注書のデータ内で、請求書の番組情報更新に必要なカラム名を定義する
   */
  export const ProgramInfoColumnNameListInOrderSheet = [
    'MProgramTicketKey',
    'MProgramProgramName',
    'MProgramOrderTicketKey',
    'OrderContent',
  ];
  /**
   * 発注書に紐づく請求書に対して、番組、発注情報を更新する
   * @param orderSheet 更新対象の発注書データ　（紐づく請求書を更新）
   * @returns 処理が完了したことを通知するPromise
   */
  export async function updateProgramInfoAsync(orderSheet: any): Promise<void> {
    /**
     * データの整合性を確認
     * @returns
     */
    const dataIsOK = () => {
      if (ValidateCheckUtility.isEmpty(orderSheet)) {
        return false;
      }
      if (ValidateCheckUtility.isEmpty(orderSheet[DbCommonColumnName.TICKET_KEY])) {
        return false;
      }

      // 発注書のデータ内で、請求書の番組情報更新に必要なカラムが存在しない場合は処理を終了
      for (let columnName of ProgramInfoColumnNameListInOrderSheet) {
        if (columnName in orderSheet == false) {
          return false;
        }
      }
      return true;
    };

    /**
     * 請求書データを更新する
     * @param invoice
     * @param orderSheet
     */
    const updateInvoice = async (invoice: any, orderSheet: any): Promise<void> => {
      const removeColumnNameList = [
        KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME,
        'GSI_Invoice_Status',
        'Baseticket',
        'TableName',
        'DisplayLabel',
        'LsiKey',
      ];
      invoice['MProgramTicketKey'] = orderSheet['MProgramTicketKey'];
      invoice['ProgramName'] = orderSheet['ProgramName'];
      invoice['MProgramOrderTicketKey'] = orderSheet['MProgramOrderTicketKey'];
      invoice['OrderContent'] = orderSheet['OrderContent'];

      // NOTE: 更新処理であることを示すため、履歴情報を追加する 値はバックエンドで変更されるため、ここでは固定値を設定する
      invoice[DbCommonColumnName.HISTORY] = {};
      invoice[DbCommonColumnName.HISTORY][DbCommonColumnName.CREATE_USER_ID] = 'system';

      removeColumnNameList.forEach((columnName) => {
        if (columnName in invoice) {
          delete invoice[columnName];
        }
      });

      return new Promise<void>((resolve, reject) => {
        let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
        let dtService = new DataTransmissionService(componentService);

        const callBack = (result: ResponseDataModel) => {
          if (!result.isCompleted) {
            reject(result);
            return;
          }
          resolve();
        };
        // 請求書データを更新する
        dtService.registerRecord(ViewType.Edit, 'Invoice', invoice, callBack, null, false);
      });
    };

    if (!dataIsOK()) {
      return Promise.resolve();
    }

    // 更新対象のデータを取得
    const orderSheetTicketKey = orderSheet[DbCommonColumnName.TICKET_KEY];
    const invoice = await fetchInvoiceByLinkOrderSheet(orderSheetTicketKey);
    if (!invoice) {
      return Promise.resolve();
    }

    // データを更新する (非同期処理をスタックする)
    updateInvoice(invoice, orderSheet);
    return;
  }
}
